import styled from '@emotion/styled'

export const Text = styled.p`
  margin-top: 8px;
`
